<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-noisecatalog-watchlist">
      <div class="bmw-lg-noisecatalog-header">
        <div class="row bmw-no-gutter">
          <div class="col-lg-4 bmw-no-gutter">
            <img src="assets/images/2015-bmw-i8-1_1035.jpg" title='noisecatalog.noiseCatalogTitle' width="250px" height="140px" />
          </div>
          <div class="col-lg-8 bmw-no-gutter">
            <div class="row bmw-no-gutter bmw-lg-noisecatalog-watchlist-title">Watchlist</div>
            <div class="row bmw-no-gutter bmw-lg-noisecatalog-watchlist-info">{{noisecatalogList?.length}} Noise
              Catalogs</div>
            <div class="row bmw-no-gutter" style="margin-top: 15px">
              <div class="col-lg-3 bmw-no-gutter">
                <a [routerLink]='["/noisecatalogplayback"]'
                  [queryParams]='{mainGroup: "", noisecatalog: "", watchlist: true, playAll: true}'>
                  <div class="bmw-lg-noisecatalog-watchlist-header-button" style="width:100px">
                    <div>
                      <i class="material-icons d48">play_circle_filled</i>
                    </div>
                    <div class="bmw-lg-noisecatalog-watchlist-header-button-label">
                      Play All
                    </div>
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="bmw-lg-noisecatalog-watchlist-list" dnd-sortable-container [sortableData]="noisecatalogList"
        [dropZones]="['widget-dropZone']">
        <div *ngFor='let noisecatalog of noisecatalogList;let noisecatalogIndex=index'
          class="row bmw-no-gutter bmw-lg-noisecatalog-watchlist-list-noisecatalog" dnd-sortable
          [sortableIndex]="noisecatalogIndex" [dragEnabled]="true" [dragData]="noisecatalog"
          (onDropSuccess)="transferDataSuccess($event)">
          <div class="col-lg-1" style="font-size: 20px; line-height: 2.7">
            <div class="col-lg-6 bmw-no-gutter">
              <div class="bmw-noisecatalog-watchlist-item-holder">
                <i class="material-icons" style="font-size:20px">unfold_more</i>
              </div>
            </div>
            <div class="col-lg-6 bmw-no-gutter" style="margin-left: 4px;padding:16px 0 16px 0">{{noisecatalogIndex+1}}</div>
          </div>
          <div class="col-lg-2 bmw-no-gutter" style="padding:16px 0 16px 0">
            <div class="bmw-lg-noisecatalog-home-thumbnail" [routerLink]='["/noisecatalogplayback"]'
              [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,noisecatalog:noisecatalog.noiseCatalogId,vimeoID:noisecatalog.noiseCatalogVimeoId, watchlist: true}'>
              <img style="cursor: pointer" src="{{videoThumbnail}}" title={{noisecatalog.noiseCatalogTitle}} />
              <!-- <div class="bmw-noisecatalog-home-overlay-text bmw-lg-noisecatalog-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-lg-8 bmw-no-gutter" style="padding:16px 0 16px 0">
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{noisecatalog.views}} views</div>
            </div>
          </div>
          <div class="col-lg-1 bmw-no-gutter bmw-align-text-right" style="margin-left: 20px;padding:16px 0 16px 0">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemTop(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemBottom(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemUp(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemDown(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter" (click)='removeFromWatchlist(noisecatalog.noiseCatalogId)'>
                  <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter">
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-lg-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-noisecatalog-channel-btn"
        [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-md-noisecatalog-watchlist">
      <div class="bmw-md-noisecatalog-header">
        <div class="row bmw-no-gutter">
          <div class="col-md-4 bmw-no-gutter">
            <img src="assets/images/2015-bmw-i8-1_1035.jpg" title='noisecatalog.noiseCatalogTitle' width="250px" height="100px" />
          </div>
          <div class="col-md-8 bmw-no-gutter">
            <div class="row bmw-no-gutter bmw-md-noisecatalog-watchlist-title">Watchlist</div>
            <div class="row bmw-no-gutter bmw-md-noisecatalog-watchlist-info">{{noisecatalogList?.length}} Noise
              Catalogs | 3 hours 38 minutes</div>
            <div class="row bmw-no-gutter" style="margin-top: 10px">
              <a [routerLink]='["/noisecatalogplayback"]'
                [queryParams]='{mainGroup: "", noisecatalog: "", watchlist: true, playAll: true}'>
                <div class="bmw-md-noisecatalog-watchlist-header-button" style="width:100px">
                  <div>
                    <i class="material-icons d48">play_circle_filled</i>
                  </div>
                  <div class="bmw-md-noisecatalog-watchlist-header-button-label">
                    Play All
                  </div>
                </div>
              </a>

            </div>
          </div>
        </div>
      </div>
      <div class="bmw-lg-noisecatalog-watchlist-list">
        <div *ngFor='let noisecatalog of noisecatalogList;let noisecatalogIndex=index'
          class="row bmw-no-gutter bmw-md-noisecatalog-watchlist-list-noisecatalog">
          <div class="col-md-1" style="font-size: 20px; line-height: 2.7">
            {{noisecatalogIndex+1}}
          </div>
          <div class="col-md-2 bmw-no-gutter">
            <div class="bmw-lg-noisecatalog-home-thumbnail" [routerLink]='["/noisecatalogplayback"]'
              [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,noisecatalog:noisecatalog.noiseCatalogId,vimeoID:noisecatalog.noiseCatalogVimeoId, watchlist: true}'>
              <img src="{{videoThumbnail}}" title={{noisecatalog.noiseCatalogTitle}} />
              <!-- <div class="bmw-noisecatalog-home-overlay-text bmw-md-noisecatalog-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-md-8 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{noisecatalog.views}} views</div>
            </div>
          </div>
          <div class="col-md-1 bmw-no-gutter bmw-align-text-right" style="margin-left: 20px">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemTop(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemBottom(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemUp(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemDown(noisecatalogIndex, noisecatalog)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter" (click)='removeFromWatchlist(noisecatalog.noiseCatalogId)'>
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-md-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-noisecatalog-channel-btn"
        [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-noisecatalog-watchlist">
      <div class="bmw-lg-noisecatalog-header">
        <div class="row bmw-no-gutter">
          <div class="col-sm-4 bmw-no-gutter">
            <img src="assets/images/2015-bmw-i8-1_1035.jpg" title='noisecatalog.noiseCatalogTitle' width="250px" height="140px" />
          </div>
          <div class="col-sm-8 bmw-no-gutter" style="padding-left: 18px">
            <div class="row bmw-no-gutter bmw-lg-noisecatalog-watchlist-title">Watchlist</div>
            <div class="row bmw-no-gutter bmw-lg-noisecatalog-watchlist-info">{{noisecatalogList?.length}} Noise
              Catalogs | 3 hours 38 minutes</div>
            <div class="row bmw-no-gutter" style="margin-top: 15px">
              <div class="col-sm-3 bmw-no-gutter">
                <a [routerLink]='["/noisecatalogplayback"]'
                  [queryParams]='{mainGroup: "", noisecatalog: "", watchlist: true, playAll: true}'>
                  <div class="bmw-lg-noisecatalog-watchlist-header-button" style="width:100px">
                    <div>
                      <i class="material-icons d48">play_circle_filled</i>
                    </div>
                    <div class="bmw-lg-noisecatalog-watchlist-header-button-label">
                      Play All
                    </div>
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="bmw-lg-noisecatalog-watchlist-list">
        <div *ngFor='let noisecatalog of noisecatalogList;let noisecatalogIndex=index'
          class="row bmw-no-gutter bmw-md-noisecatalog-watchlist-list-noisecatalog">
          <div class="col-sm-1" style="font-size: 20px; line-height: 2.7">
            {{noisecatalogIndex+1}}
          </div>
          <div class="col-sm-2 bmw-no-gutter">
            <div class="bmw-lg-noisecatalog-home-thumbnail" [routerLink]='["/noisecatalogplayback"]'
              [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,vimeoID:noisecatalog.noiseCatalogVimeoId, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{noisecatalog.noiseCatalogTitle}} />
              <!-- <div class="bmw-noisecatalog-home-overlay-text bmw-xs-noisecatalog-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-sm-8 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{noisecatalog.views}} views</div>
            </div>
          </div>
          <div class="col-sm-1 bmw-no-gutter bmw-align-text-right" style="margin-left: 20px">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemTop(noisecatalogIndex, noisecatalog)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemBottom(noisecatalogIndex, noisecatalog)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemUp(noisecatalogIndex, noisecatalog)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemDown(noisecatalogIndex, noisecatalog)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter" (click)='removeFromWatchlist(noisecatalog.noiseCatalogId)'>
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-sm-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-noisecatalog-channel-btn"
        [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-noisecatalog-watchlist">
      <div class="bmw-xs watchlist-header">
        <div class="row bmw-no-gutter bmw-lg-noisecatalog-watchlist-info" style="padding-left: 10px">
          {{noisecatalogList?.length}} Noise Catalogs | 3 hours 38 minutes</div>
        <div class="row bmw-no-gutter" style="color:#1c69d4">
          <a [routerLink]='["/noisecatalogplayback"]'
            [queryParams]='{mainGroup: "", noisecatalog: "", watchlist: true, playAll: true}'>
            <div style="float:right;margin-left: 5px">
              <i style="font-size: 36px;" class="material-icons">play_circle_filled</i>
            </div>
            <div style="float:right; font-size: 24px;">Play All</div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-noisecatalog-watchlist-list">
        <div *ngFor='let noisecatalog of noisecatalogList;let noisecatalogIndex=index'
          class="row bmw-no-gutter bmw-md-noisecatalog-watchlist-list-noisecatalog">
          <div class="col-xs-6 bmw-no-gutter" style="padding-left: 3px">
            <div class="bmw-lg-noisecatalog-home-thumbnail" [routerLink]='["/noisecatalogplayback"]'
              [queryParams]='{mainGroup:noisecatalog.mainGroup.mainGroupNumber,noisecatalog:noisecatalog.noiseCatalogId,vimeoID:noisecatalog.noiseCatalogVimeoId, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{noisecatalog.noiseCatalogTitle}} />
              <!-- <div class="bmw-noisecatalog-home-overlay-text bmw-xs-noisecatalog-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-xs-5 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='noisecatalog.noiseCatalogDisplayNumber'></div>
            <div class="row bmw-no-gutter"
              [innerHTML]='noisecatalog.noiseCatalogTitle.length > 19 ? noisecatalog.noiseCatalogTitle.substr(0,20)+"..." : noisecatalog.noiseCatalogTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='noisecatalog.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{noisecatalog.views}} views</div>
            </div>
          </div>
          <div class="col-xs-1 bmw-no-gutter bmw-align-text-right">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemTop(noisecatalogIndex, noisecatalog)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_top</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move to top
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemBottom(noisecatalogIndex, noisecatalog)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">vertical_align_bottom</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move to bottom
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === 0}'
                  (click)='moveItemUp(noisecatalogIndex, noisecatalog)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_upward</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move up
                  </div>
                </li>
                <li class="row bmw-no-gutter" [ngClass]='{"disabled": noisecatalogIndex === noisecatalogList.length - 1}'
                  (click)='moveItemDown(noisecatalogIndex, noisecatalog)'>
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">arrow_downward</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Move down
                  </div>
                </li>
                <li class="row bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" (click)='removeFromWatchlist(noisecatalog.noiseCatalogId)'>
                    Remove from Watchlist
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter" style="padding-left: 7px">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="padding-left: 5px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter pointer bmw-xs-noisecatalog-channel-btn bmw-noisecatalog-channel-btn"
        [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' (click)='applyChanges()'>
        <label class="pointer" style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>